/** The planned moments' runs, as the host sees them: the room's socket says each change, and a press asks the API. */
import { useCallback, useEffect, useState } from "react";
import type { MomentAction, MomentRun } from "../../shared/live-moments";
import type { LiveStudio } from "../../shared/types";
import { api } from "../lib/api";

export function useMoments(info: LiveStudio, socketRuns: MomentRun[] | null, showToast: (words: string) => void) {
  const [runs, setRuns] = useState<MomentRun[]>(info.runs);
  const [busy, setBusy] = useState<string | null>(null);
  useEffect(() => {
    if (socketRuns) setRuns(socketRuns);
  }, [socketRuns]);
  const act = useCallback(
    (id: string, action: MomentAction) => {
      setBusy(id);
      api.studio
        .moment(info.webinarId, id, { do: action }, info.sessionId)
        .then((res) => setRuns(res.runs))
        .catch((err: unknown) => showToast(err instanceof Error ? err.message : "That did not go through. Try again."))
        .finally(() => setBusy(null));
    },
    [info.webinarId, info.sessionId, showToast],
  );
  return { runs, busy, act };
}
